
<script>
import store from '../store';
export default {
    computed: {
        image() {
            // console.log(store.data)
            return store.data.head.images[0];
        }
    },
    methods: {
        // clearStorage() {
        //     localStorage.removeItem('HQreturnData2')
        //     if (!localStorage.getItem('HQreturnData2')){
        //         alert("已清除掉localstorage");
        //     }
        // }
    }
}
</script>

<template>
    <div class="wrap" id="head-img">
        <!-- <a @click="clearStorage" style="display: block; position:fixed; top: 0; left: 100px;width: 200px; height:30px; background:yellow;font-size:14px;line-height:30px;">点一下清除localstorage</a> -->
        <img :src="image" alt="">
    </div>
</template>

<style lang="stylus" scoped>
.wrap img
    width 100%
</style>